var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h53.3v26.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h53.3v13.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m30.7 17.6-8.2 8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M31.2 17v.4l-.2-.2v.2h-.2.4l-.3.2h-.2v-.1l-.1-.1V17v.2h.2q0-.2.1 0l-.1-.2zl.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m32.3 18.6-10.5 5.9-.1-.1 10.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m33 18.2-.3.3v-.2l-.2.1h-.1l.1.2h.2-.5v-.2l.1-.3v.3l.1-.1h.2l-.1-.2h.3l.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m31.4 18.1-9.5 7.1 9.4-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m32 17.7-.2.3-.1-.2v.2h-.2.1l.2.1h-.5v-.4.1l.1.1v-.1h.2l-.1-.1.3-.1.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m22.6 17.6 8.2 8.1-8-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M22.1 17v.4l.3-.2v.2h.1-.3l.2.2h.2l.1-.1V17v.2h-.1q-.1-.2-.2 0l.1-.2-.3-.1-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m21 18.6 10.6 5.9v-.1l-10.4-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m20.4 18.2.2.3.1-.2v.1h.2l-.1.2h-.2.5V18v.2l-.1.1v-.1h-.3l.2-.2zl-.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m22 18.1 9.4 7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m21.4 17.7.1.3.2-.2v.2h.2-.2l-.2.1h.5v-.4.1l-.1.1v-.1h-.2l.1-.1-.3-.1-.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    d: "M25 23.6c.3-.2 1.3-.3 1.4-.3q-1.1.7-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    d: "M25 23.6q.2.4 1.4-.3-.7.3-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 23.6q.2.4 1.4-.3-.7.3-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 23.6q.7-.3 1.4-.3-1.1.7-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m29 18.4-2.2 4.3h-.2l-.3.2q-.2.4 0 .4l-.2.3-.3.2-.4.8-.3.5-.8-.5c.3-.6 1.3-1.5 1.2-1.6q.5-.7.9-.9.3-.2.3-.5l.3-.1 1.6-3.2.1.1.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "m29 17.4.2.1.1.1-2.5 5.1h-.2l1.7-3.5.8-1.6H29zl1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m29 17.4.2.1.1.1-2.5 5.1h-.2l1.7-3.5.8-1.6H29zl1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 22.7q-.4 0-.2.4m.1-.2h-.1m1.2-1.1q-.1.7-.4.8l-.3.7-.6 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "m26.8 22.7-.8-.3-.5.7.6.4h.1v-.2q0-.4.3-.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.8 22.7-.8-.3-.5.7.6.4h.1v-.2q0-.4.3-.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M26.5 22.7q-.3 0-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 22.7q-.3 0-.4.3m-.3 0h.1zm.2-.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M28.8 18.8v-.1l-.4-.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 18.8v-.1l-.4-.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    d: "m24.5 23.8 1.4-.3q-1 .8-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    d: "M24.5 23.8q.3.5 1.4-.3-.6.3-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.8q.3.5 1.4-.3-.6.3-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.5 23.8 1.4-.3q-1 .8-1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m28.4 18.5-2 4.4H26l-.3.2q-.1.4 0 .4l-.2.3-.2.2-.4.8-.3.5-.9-.4 1.3-1.7q.4-.7.8-.9t.3-.5l.3-.2 1.5-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4 18.5-2 4.4H26l-.3.2q-.1.4 0 .4l-.2.3-.2.2-.4.8-.3.5-.9-.4 1.3-1.7q.4-.7.8-.9t.3-.5l.3-.2 1.5-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M28.4 17.6q.3 0 .2.2l-2.3 5.1H26l1.7-3.5.8-1.6h-.3v-.2l1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M28.4 17.6q.3 0 .2.2l-2.3 5.1H26l1.7-3.5.8-1.6h-.3v-.2l1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 23q-.3-.1-.2.3m.1-.2H25m1.2-1.1q-.1.7-.3.9c-.2.1-.4.6-.3.6l-.7 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M26.3 23q-.1-.4-.8-.4l-.5.7.7.4v-.2q0-.3.3-.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 23q-.1-.4-.8-.4l-.5.7.7.4v-.2q0-.3.3-.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "m26 23-.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 23-.4.1m-.3.1h.1zm.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M28.2 19v-.2l-.3-.1h-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 19v-.2l-.3-.1h-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 19v-.2l-.3-.1h-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    d: "m28.4 23.6-1.4-.3q1 .7 1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    d: "M28.4 23.6c0 .2-.8.2-1.4-.3q.7.3 1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4 23.6c0 .2-.8.2-1.4-.3q.7.3 1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4 23.6-1.4-.3q1 .7 1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m24.4 18.3 2.1 4.4h.3l.3.2q.1.3 0 .4l.2.3.2.2.4.7.4.6.8-.5-1.3-1.6c-.2-.4-.6-1-.8-.9q-.4-.3-.3-.6h-.3l-1.6-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M24.3 17.3v.1h-.1l-.2.1 2.5 5.2h.3L25 19l-.8-1.5zl.1-.2-1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M24.3 17.3v.1h-.1l-.2.1 2.5 5.2h.3L25 19l-.8-1.5zl.1-.2-1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 22.7q.3 0 .2.4m-1.4-1.3.4.8q.4.4.3.7l.7 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M26.5 22.7c.2 0 .5-.4.9-.3l.5.7-.7.4v-.2q0-.3-.3-.4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 22.7c.2 0 .5-.4.9-.3l.5.7-.7.4v-.2q0-.3-.3-.4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "m27 22.7.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.7.3.2m.3 0v.1h-.1zm-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "m24.6 18.8-.1-.1.4-.2h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 18.8-.1-.1.4-.2h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    d: "M28.8 23.8q-.6-.3-1.4-.3 1.1.8 1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    d: "M28.8 23.8q-.2.5-1.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 23.8q-.2.5-1.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 23.8q-.6-.3-1.4-.3 1.1.8 1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m25 18.5 2 4.4h.2l.4.2v.4l.1.3.3.2.4.8.3.5.8-.4c-.3-.7-1.2-1.6-1.2-1.7l-.8-.9q-.4-.2-.4-.5l-.3-.2-1.5-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 18.5 2 4.4h.2l.4.2v.4l.1.3.3.2.4.8.3.5.8-.4c-.3-.7-1.2-1.6-1.2-1.7l-.8-.9q-.4-.2-.4-.5l-.3-.2-1.5-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M24.9 17.6h-.1l-.2.2 2.4 5.1h.2l-1.6-3.5-.8-1.6h.2zl-1-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 17.6h-.1l-.2.2 2.4 5.1h.2l-1.6-3.5-.8-1.6h.2zl-1-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M24.9 17.6h-.1l-.2.2 2.4 5.1h.2l-1.6-3.5-.8-1.6h.2zl-1-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 17.6h-.1l-.2.2 2.4 5.1h.2l-1.6-3.5-.8-1.6h.2zl-1-1.9zm3.2 5.4q.4-.1.2.3M27.1 22l.4.9c.2.1.3.6.3.6l.6 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M27 23q.3-.4.8-.4l.5.7-.6.4h-.1v-.2q0-.3-.3-.4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 23q.3-.4.8-.4l.5.7-.6.4h-.1v-.2q0-.3-.3-.4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "m27.4 23 .4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.4 23 .4.1m.3.1H28m-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    d: "M25.1 19v-.2l.4-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 19v-.2l.4-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 19v-.2l.4-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    d: "m26.3 20.9 3-3.2H29l-3 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    d: "m29.1 17.7-.4-.2.3-.3q.1.3.3.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m29.3 17.5.3.2.3-.2v.5q-.4.3-.6.2l.1-.3-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3 17.5.3.2.3-.2v.5q-.4.3-.6.2l.1-.3-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m29.4 17.5-.2.3-.1-.1.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25.7 24.2-.1.7.1-.1.2-.7-.1-.2zm.2-1.7-.3 1.3q0 .1.2 0l.1-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    d: "M26.3 23.7v-.1l-.1.2.1.4V24l.1-.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    d: "M25.6 25q.2 0 .3-.9V24h.1v-.2q0-.1.2 0l-.1.8v.2h-.2zm.3-2.1V24h.1v-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 24-.1.1q-.2.9-.3.8.3.1.3-.1h.2v-1q0-.2 0 0zm0 0-.2-.3.1-.8.1.3zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    d: "M25.8 24.9v.2h.2v-.3zm.2-.9v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    d: "m26.3 24-.1-.2-.2 1q0 .2-.2.3s.1.9.4.6l.1-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    d: "m26.4 23.8-.1 1.7v-1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    fillRule: "evenodd",
    d: "M26 23.2v.6q0-.2.2 0v-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M26 24s-.1-.5-.4-.2v.3l.1.2h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "m24 19.8-.1-1.2-1-1s-.1.8-.5 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 19.8-.1-1.2-1-1s-.1.8-.5 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "m24 19.8.2-.9-.7-.6-.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 19.8.2-.9-.7-.6-.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M24.6 20.4c0-.4-.1-.4.2-1l-.6-.5-.2.9.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 20.4c0-.4-.1-.4.2-1l-.6-.5-.2.9.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M22.3 22.5V21l.2-1.7-1.2-.7-.2 2.4v1.8c.1.8.3 1 .6 1.4.5.5 1.6.2 1.6.2 1-.2 1.5-.8 1.5-.8l-.8.1c-1.1 0-1.5.2-1.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 22.5V21l.2-1.7-1.2-.7-.2 2.4v1.8c.1.8.3 1 .6 1.4.5.5 1.6.2 1.6.2 1-.2 1.5-.8 1.5-.8l-.8.1c-1.1 0-1.5.2-1.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "m25.4 23.2-.4.2h-.7c-1.4 0-1.2-.8-1.2-2.3l.1-1.4-1-.6q-.3 1.3-.2 2c0 .5-.2 1.4 0 1.8.2 1 1 1 2 .9l.8-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "m25.5 23.2-.5.2h-.7q-1.6.2-1.5-2.2c0-.6 0-.9.2-1.7l.6.4-.1.8q.1 2 2 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 23.2-.5.2h-.7q-1.6.2-1.5-2.2c0-.6 0-.9.2-1.7l.6.4-.1.8q.1 2 2 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 19.2c0 .2.6 1 1 1.2m-1-.6c.2.2.9 1.2 1.2 1.2m-1.3.3q.2.4.8.8m-.6.3c.3.3 1.1 1 2 1m-2-.5c.2.2.5 1.1 2 .7m-2.2-.5c0 .2.8 1.4 2.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M23.1 22v-1.4l.2-1.7-1.1-.8-.2 2.5-.1 2q.3 1 .6 1.1c.6.5 1.8.5 2 .4.9-.3 1.3-.9 1.3-.9h-1c-1 0-1.6 0-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1 22v-1.4l.2-1.7-1.1-.8-.2 2.5-.1 2q.3 1 .6 1.1c.6.5 1.8.5 2 .4.9-.3 1.3-.9 1.3-.9h-1c-1 0-1.6 0-1.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "m26.3 22.8-.5.1h-.6c-1.5.1-1.3-.8-1.2-2.2v-1.3l-.9-.6-.3 1.8v1.9c.3 1 1 1 2 .9q.9-.1.8-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m26.3 22.8-.5.2h-.6q-1.6.2-1.6-2.3l.2-1.4 1 .8-.2.5q0 2 1.7 2.2l.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 22.8-.5.2h-.6q-1.6.2-1.6-2.3l.2-1.4 1 .8-.2.5q0 2 1.7 2.2l.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.8c.1.1.7 1 1 1.2m-.9-.6c.1.1.8 1.1 1.1 1.2m-1.3.3.8.8m-.5.3c.3.3 1.1 1 1.9 1m-2-.5c.2.2.6 1 2 .7m-2.2-.6c.1.3.9 1.5 2.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m21.4 18.7-.1.5v1.3h-.1v-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 18.7-.1.5v1.3h-.1v-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 18.7-.1.5v1.3h-.1v-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "M21.3 18.5V20l-.1.4H21l.1-.4.2-1.4s0 .3 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 18.5V20l-.1.4H21l.1-.4.2-1.4s0 .3 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M21.3 18.5V20l-.1.4H21l.1-.4zs0 .4 0 0m.9-.3V20q0 .2-.2 0v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 18.5V20l-.1.4H21l.1-.4zs0 .4 0 0m.9-.3V20q0 .2-.2 0v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 18.2V20q0 .2-.2 0v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m22.2 18-.1.9v1h-.2v-.4l.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.2 18-.1.9v1h-.2v-.4l.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 19.5-.1.4h.1zV19l.2-.8zm.1-.1H22m0 .1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M22.9 17.6v1.5zm0 0v1.5zm0 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 18.8h.1m0-1.2v1.5zm3.4 3.9h.2m-.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    fillRule: "evenodd",
    d: "M24.4 23.7c0 .2-.7.5-1.1 0q-.7-.8 0-1l4.6-4.5.2-.3.8.8-.2.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    d: "M28.1 18c.3-.4 1.1.4.9.6-.2.3-1-.4-.9-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccccf",
    fillRule: "evenodd",
    d: "M29 18.6c-.3.1-.9-.4-.8-.6.2-.2.9.5.7.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 19a1 1 0 0 1-.9-.8M26 22a1.4 1.4 0 0 1-1-1m.8 1.2a1.4 1.4 0 0 1-1-1m0 2.2q-1-.3-1.1-1m.8 1.2a2 2 0 0 1-1-1m-.2 1.2h-.2m1.1-.1q-.2.3-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m23 23.8.2.1.1-.1-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 23.8.2.1.1-.1-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3 23.7q0 .3-.2.2m1.1-.2q-.2.3-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m27.6 24.2.1.7-.1-.1-.2-.7.1-.2zm-.1-1.7.2 1.3q0 .1-.2 0l-.1-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    d: "m27 23.7.1-.1v.6H27z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    d: "M27.7 25q-.2 0-.3-.9V24l-.1-.2q0-.1-.2 0l.1.8v.2h.2zm-.3-2.1.1.8-.1.3v-.2l-.1-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 24v.1q.1.9.3.8-.3.1-.3-.1h-.1v-.2l-.2-.8q.1-.2.2 0zm.1 0 .1-.3-.1-.8-.1.3v.8m.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    d: "M27.5 24.9v.2h-.1l-.1-.3zm-.2-.9v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    d: "m27 24 .2-.2v1q0 .2.3.3s-.1.9-.4.6V24m-.1-.2h-.2l.2 1.7v-1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    fillRule: "evenodd",
    d: "M27.3 23.2v.6q0-.2-.1 0v-.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M27.4 24s0-.5.3-.2v.3l-.1.2h-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "m29.3 19.8.2-1.2 1-1s0 .8.4 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3 19.8.2-1.2 1-1s0 .8.4 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "m29.3 19.8-.2-.9.7-.6.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3 19.8-.2-.9.7-.6.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M28.7 20.4c0-.4.1-.4-.1-1l.6-.5.1.9-.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 20.4c0-.4.1-.4-.1-1l.6-.5.1.9-.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M31 22.5q.2-.7 0-1.5l-.2-1.7 1.2-.7.2 4.2c-.1.8-.2 1-.5 1.4-.6.5-1.7.2-1.7.2-1-.2-1.5-.8-1.5-.8l.8.1c1.1 0 1.6.2 1.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 22.5q.2-.7 0-1.5l-.2-1.7 1.2-.7.2 4.2c-.1.8-.2 1-.5 1.4-.6.5-1.7.2-1.7.2-1-.2-1.5-.8-1.5-.8l.8.1c1.1 0 1.6.2 1.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "m27.9 23.2.5.2h.6c1.5 0 1.3-.8 1.2-2.3v-1.4l.9-.6q.3 1.3.3 2v1.8c-.3 1-1 1-2 .9l-.9-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "m27.9 23.2.5.2h.6q1.7.2 1.5-2.2c0-.6 0-.9-.2-1.7l-.6.4.2.8q-.2 2-2 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.9 23.2.5.2h.6q1.7.2 1.5-2.2c0-.6 0-.9-.2-1.7l-.6.4.2.8q-.2 2-2 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 19.2c-.1.2-.7 1-1 1.2m.9-.6c-.1.2-.8 1.2-1.2 1.2m1.3.3q-.1.4-.8.8m.6.3c-.3.3-1.1 1-1.9 1m2-.5c-.3.2-.6 1.1-2 .7m2.1-.5c0 .2-.8 1.4-2.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M30.2 22v-1.4l-.2-1.7 1.1-.8.4 4.5q-.4 1-.7 1.1c-.5.5-1.8.5-2 .4-.8-.3-1.2-.9-1.2-.9h.9c1 0 1.6 0 1.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2 22v-1.4l-.2-1.7 1.1-.8.4 4.5q-.4 1-.7 1.1c-.5.5-1.8.5-2 .4-.8-.3-1.2-.9-1.2-.9h.9c1 0 1.6 0 1.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "m27 22.8.5.1h.7c1.4.1 1.2-.8 1.2-2.2v-1.3l.8-.6q.4 1.3.3 1.8c0 .5.2 1.5 0 1.9-.2 1-1 1-2 .9l-.8-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m27 22.8.5.2h.7q1.6.2 1.5-2.3l-.2-1.4-1 .8.2.5q0 2-1.7 2.2l-.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.8.5.2h.7q1.6.2 1.5-2.3l-.2-1.4-1 .8.2.5q0 2-1.7 2.2l-.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 18.8c0 .1-.7 1-1 1.2m1-.6c-.2.1-.9 1.1-1.2 1.2m1.3.3q-.2.4-.8.8m.6.3c-.4.3-1.2 1-2 1m2-.5c-.2.2-.6 1-2 .7m2.2-.6c-.1.3-.9 1.5-2.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "M32 18.7v1.8h.2V20l-.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 18.7v1.8h.2V20l-.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M32 18.7v1.8h.2V20l-.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "m32 18.5.1.8v1.1h.2V20zs0 .3 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 18.5.1.8v1.1h.2V20zs0 .3 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m32 18.5.1.8v1.1h.2V20zs0 .4 0 0m0 1.5h.1Zm.1 0h.1Zm0-.2h.1Zm0 .1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.2 20 .1.3h-.1zl-.1-.7-.1-.8c0 .4 0 0 0 0zm-.2 0h.1m0-.2h.1m-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "M31.1 18.2v.5q.2.5 0 .8v.5q.1.2.2 0v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M31.1 18.2v.5q.2.5 0 .8v.5q.1.2.2 0v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    d: "m31.1 18 .1.9v.6l.1.4h.2l-.1-.4-.2-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.1 18 .1.9v.6l.1.4h.2l-.1-.4-.2-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m31.1 18 .1.9v.6l.1.4h.2l-.1-.4-.2-1.4m0 1.5h.2Zm.1 0h.2Zm0-.1h.2Zm0-.2h.1Zm0 0h.1Zm0 .3h.1Zm-.7-1.9v1.5h-.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 19.5v.4l-.1-.4V19l-.3-1zm0 0h-.1m-.1-.1h.2m-.9-1.8v1.5h-.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M30.5 17.6v1.5h-.2l.1-.3zm0 1.1h-.1Zm0 .1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18.7h-.1m.1-1.1v1.5h-.2l.1-.3zm-2.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27 21.4h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 21.5h-.2m.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "m24.3 18 .2-.3.3-.2v.1l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    fillRule: "evenodd",
    d: "m24.3 17.9 2.5 3.2V21l-2.4-3.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "m24.3 17.3.2-.2q0-.2-.3-.2l-.4.2-.2.4.2.5v.4h.3l.2-.4.2-.3.3-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 17.3.2-.2q0-.2-.3-.2l-.4.2-.2.4.2.5v.4h.3l.2-.4.2-.3.3-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 17.3H24l-.2.2m1 0-.3.1-.3.3-.3.3m.7-.7-.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    fillRule: "evenodd",
    d: "M29 23.7c0 .2.6.5 1 0q.7-.8 0-1l-4.5-4.5q-.2 0-.3-.3l-.8.8.3.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    d: "M25.2 18c-.2-.4-1 .4-.8.6.2.3 1-.4.8-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccccf",
    fillRule: "evenodd",
    d: "M24.4 18.6c.2.1.8-.4.7-.6s-.9.5-.7.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7 19a1 1 0 0 0 .8-.8m2 3.8q.6-.3.9-1m-.8 1.2q.7-.2 1-1m.1 2.2q.8-.3 1-1m-.8 1.2a2 2 0 0 0 1-1m.1 1.2h.2m-1.1-.1q.3.3.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m30.3 23.8-.1.1a.1.1 0 0 1-.2-.1q0-.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 23.8-.1.1a.1.1 0 0 1-.2-.1q0-.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 23.7q0 .3.2.2m-1.1-.2q.3.3.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m28.3 14.6.4 1a2 2 0 0 1-.6 1.8q-.7.5-1.3.5l-.6.2V18l.7-.1q1-.2 1.6-1 .6-1.4-.2-2.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m28.9 17-.3.2h-.3l-.1.2h.5zm-.5.2h-.1zm.5-.2-.8.4zm-.2.5h-.4l-.4.1q.5.3.8-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.4 17.8c-.1 0-.7-.3-.8 0q.3.2.8 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.2 18H28l-.2-.1h-.5q.4.4 1 0m.1-.2h-.8zm.4-.3-1 .1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m28.2 18-.9-.1v-.1h-.1.1c.6.3.6.2 1 .2m-1-.3-.1.1zm1.2-.7c0-.2-.1 0-.3-.4v-.4l.2.4zm-.4-.7.2.3.2.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.1 16.3.2.3.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m28.2 16.4.3.5q0-.3-.3-.4m1 .3h-.3l-.1.2h-.2l-.1.2h.1q.3 0 .4-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.4 17v.1l.4-.2.3-.2-.3.2zm.8-.7-.2.1-.1.1h-.1l-.2.3h.2q.2 0 .3-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.5 16.8q.5-.1.7-.5zm.7-.9-.2.2-.1.1-.1.2h.3v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m29 16.2-.3.3zm.1-.5v.2h-.2v.1l-.1.2h.1l.1-.1.1-.2zm-.1.3-.3.3zm-.4.8v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.6 15.2h-.1zm.5 0q-.3.3-.3.7c.3.2.3-.4.3-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.8 14.8v.6q.3 0 0-.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.6 14.5q.3.4 0 .7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.4 14.3q-.2.2 0 .6.4-.2 0-.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.3 14.7q-.3 0-.3-.5.4.2.3.5m.2.3q-.2-.3-.5-.3 0 .4.5.3m.1.4q-.3 0-.5-.4.4 0 .5.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.6 15.7v-.2l-.3-.3q0 .4.3.5m.1.3-.5-.5q0 .4.5.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.6 16.3q-.4-.1-.3-.6 0 .3.2.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.6 16.6v-.2l-.4-.4.1.4zm-.4.6q-.3-.4 0-.7.2.3 0 .7m.2-2.5-.3-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4 14.7-.3-.5zm.2 1.8v-.2l-.4-.4.1.4zm-.4.6q-.3-.4 0-.7.2.3 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.2 17.2v-.7zm.4-.6-.4-.6c0 .4.4.4.4.7m0-.2-.3-.6q.1.4.4.6m.1-.4-.5-.5q.3.2.5.6m0-.2-.5-.6zm0-.4q-.4-.1-.6-.4.2.3.6.4m-.2-.3-.5-.4zm.6.1-.3.7zm-.3-.4-.1.7zm-.1-.3v.8zm-.3-.2v.6zM28 17q.1.4-.2.6c-.1-.4.1-.3.2-.6m0 0-.2.6zm.6-1.7V15zm0 1.5v-.1m-.3.5V17",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M28.2 17h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M28.3 17v.2zm-1 .9h-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M27.3 18v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m27.7 17.2-.3.5q0-.3.3-.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M27.7 17.2q0 .3-.4.6zm-.3.2-.2.3-.2.1q.1-.3.4-.4m0 0-.4.5zM25 14.6l-.4 1a2 2 0 0 0 .6 1.8q.8.5 1.4.5l.5.2V18l-.7-.1q-1-.2-1.6-1-.5-1.4.2-2.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m26.2 17.8-.6.3h-.3l.2-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.3 18 .7-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 18 .7-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m26 17.4.3.3v.2-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m26.4 17.9-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.9-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25 14.7.2-.4h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.3 14.3-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 14.3-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25 14.8v-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25 14.3v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14.3v.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25 14.8.3-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.3 14.5-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 14.5-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.8 15v-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M24.8 14.4v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 14.4v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.8 15.1-.2-.4v-.2l.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.6 14.5.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 14.5.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.7 15.3-.2-.4v-.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.5 14.8.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.5 14.8.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.8 15 .4-.2.1-.1h-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.3 14.7-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 14.7-.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.8 15.1h.4v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25.2 15H25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 15H25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.7 15.4.4-.2v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25.2 15q-.2.3-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 15q-.2.3-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.7 15.3V15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7 15.3V15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.7 15.3.1-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.7 15.3.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 15.1h-.1v.1m0-.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.6 15.6-.2-.4V15v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.4 15 .1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.4 15 .1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.6 15.6.4-.2.1-.1q-.3 0-.5.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.1 15.3-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.1 15.3-.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.6 15.8.4-.2.1-.2-.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.1 15.5-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.1 15.5-.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.6 15.8-.3-.4v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.3 15.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 15.3.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.6 16q.3 0 .4-.2v-.2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25 15.6q0 .3-.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15.6q0 .3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.6 16.1-.4-.3v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M24.2 15.6q0 .3.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 15.6q0 .3.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.6 16h-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 16h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.6 16h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 16h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.6 16.4-.4-.4v-.2.1q.3.2.4.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.1 15.9.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.1 15.9.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.6 16.4q.2 0 .4-.4v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25 15.8-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 15.8-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.7 16.6.4-.4V16v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25.1 16q0 .3-.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 16q0 .3-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.7 16.6q-.2 0-.5-.3L24 16h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.1 16 .4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.1 16 .4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25 17.1.2-.4v-.2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.2 16.5-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2 16.5-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25 17.1-.6-.1-.2-.2h.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.2 16.8.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.2 16.8.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.8 17-.5-.3-.1-.2h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.2 16.5.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.2 16.5.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m24.9 17 .3-.6v-.2l-.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.2 16.3-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2 16.3-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.8 16.8h-.1v-.2.1h-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 16.8h-.1v-.2.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.5 16.7h.1m0-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M24.8 16.8v-.2zh.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 16.8v-.2zh.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 16.5h-.1v.1m-.1-.1v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.1 17.3h-.5l-.2-.1h.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M24.4 17.2h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 17.2h.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25.2 17.3.1-.4v-.2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25.3 16.7v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 16.7v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.5 17.5h-.9.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m24.6 17.4.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 17.4.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.5 17.5v-.4l-.1-.2v.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M25.4 17v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 17v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.3 17.4H25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 17.4H25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 17.3h.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.3 17.4v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 17.4v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.3 17v.2zm-.1.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "m25.7 17.7-.6.1h-.2l.1-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M24.9 17.8h.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 17.8h.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.9 17.7h-.2zv.1h-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 17.7h-.2zv.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.5 17.8h.1v.1h-.1m0-.1h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M25.8 17.7v-.5h-.2q0 .3.2.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.6 17.1.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 17.1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M26 17.8v-.2h-.2.1v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 17.8v-.2h-.2.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.8 17.4v.1h.1zm0 .1v.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.6 17.4-.1.5.3-.5h.2l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.4-.1.5.3-.5h.2l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.9 17.8-.2.5.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 17.8-.2.5.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26 17.6-.3.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 17.6-.3.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26 17.5-.2.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 17.5-.2.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.1 17.5-.3.4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 17.5-.3.4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.1 17.3-.2.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 17.3-.2.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26 17.7-.2.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 17.7-.2.5.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.2 17.6-.1.4.3-.4c.2-.3-.2 0-.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 17.6-.1.4.3-.4c.2-.3-.2 0-.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.2 17.6v.5l.2-.5q0-.2 0 0v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 17.6v.5l.2-.5q0-.2 0 0v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.1 17.5-.3.5.5-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 17.5-.3.5.5-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.2 17.6-.3.4.5-.5h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 17.6-.3.4.5-.5h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.2 17.7-.3.4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 17.7-.3.4.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.2 17-.2.5.4-.3q-.1-.2-.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 17-.2.5.4-.3q-.1-.2-.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.2 17.5-.2.4.4-.4v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 17.5-.2.4.4-.4v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.2 17.3s.2-.4 0 .1q-.3.6-.3.4l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 17.3s.2-.4 0 .1q-.3.6-.3.4l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.5 17.3s.2-.4 0 0q-.4.6-.4.4l.2-.3.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 17.3s.2-.4 0 0q-.4.6-.4.4l.2-.3.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.4 17.1-.3.5.4-.4h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.1-.3.5.4-.4h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M29.4 21q0 1.1-.8 2.1t-2 .9q-1.1 0-1.9-.9t-.8-2.2.8-2.2 2-.9 1.9 1q.8.8.8 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#390",
    strokeWidth: 0.1,
    d: "M24.5 21q.2-2.4 2.2-2.6c2-.2 2.2 1 2.2 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M24 21c0 1.7 1.2 3 2.7 3 1.4 0 2.6-1.3 2.7-3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.4 21q0 1.1-.8 2.1t-2 .9q-1.1 0-1.9-.9t-.8-2.2.8-2.2 2-.9 1.9 1q.8.8.8 2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M26.2 18.8v.3l.1.2-.5-.3.3.5h-.5l.2.1.2.1-.5.2h.5v.1l-.2.2-.2.1h.5l-.3.4.5-.3v.6-.3l.2-.2.2.6v-.6h.1l.1.2.2.3v-.3l-.1-.2.5.2-.3-.4h.6l-.3-.1-.2-.1V20l.6-.1-.6-.1.2-.2.3-.2h-.3l-.3.2v-.1l.3-.5-.4.4v-.6l-.1.2-.2.3-.1-.6-.1.5-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.2 19.7h-.5v.3-.3q.2-.2.4 0m-.1 0h-.2zh.2zm0 .1h-.2zm-.2 0h.3zm.2 0h-.2zm-.3.2h-.1v.1zm0 .3v-.1h-.1zm0 0h-.1zm.2 0h-.2zm-.7-.6h.4v.3-.3q-.2-.2-.4 0m.2 0h-.2zm-.2.1h.3zm.3 0h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.2 19.8h.3zm.3.2h.2v.1zm-.1.3.1-.1zm0 0h.2zm.1 0h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M27 21.5h.7l-.2-.1-.2-.2h1.5V21l-.3-.1-.4-.3h-.2l-.4-.4-.6-.4h-.2l-.5.2-.3.2-.6.4-.8.4c.7 0-.6.2 2.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.3 20.8 1-.7h.2l-.2.2h.1l-.1.2-.2.1h.2l.2-.2h.1l-.2.3-.3.3-.5.3c0-.2-.3.1-1-.2m2.5 0H27zV21h.4-.2.4v-.1h.3v.1h-.2v.1h.2l.1-.1h.1v.2h.3V21h.3-.3l-.3.1H28m-1 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 20.8 1-.7h.2l-.2.2h.1l-.1.2-.2.1h.2l.2-.2h.1l-.2.3-.3.3-.5.3c0-.2-.3.1-1-.2m2.5 0H27zV21h.4-.2.4v-.1h.3v.1h-.2v.1h.2l.1-.1h.1v.2h.3V21h.3-.3l-.3.1H28m-1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M26.8 21.6h1.4l-.4-.3h-.2l-.2-.2h-.1L27 21l-.2-.2-.2-.1-.3.1-.2.2-.4.2-.5.2.6.1.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "m25.8 21.2.6-.3h.1v.1l-.2.2h.1l.1-.1h.1-.1v.1l-.2.2-.3.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 21.2.6-.3h.1v.1l-.2.2h.1l.1-.1h.1-.1v.1l-.2.2-.3.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a6de",
    d: "M26.7 17.9c-1.5 0-2.8 1.3-2.8 3s1.3 3.1 2.8 3.1 2.7-1.4 2.7-3c0-1.8-1.2-3.2-2.7-3.2m0 .6c1 0 2 1 2 2.4s-1 2.4-2 2.4q-1.8-.2-2-2.4c0-1.3.9-2.4 2-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M26.8 23v-.5q.3-.2.4 0v.5zm.2-.6v.6zm.1-.1v.6zm-.1-.2.1.1m0 0v.6zm0-.1v.6zM27 22v.6zm.1-.2-.1.1m0 0v.6zm-.1-.1v.1m0 0v.6zm0-.2-.1.1m.1 0v.1m-.2 0v.6zm0 0v.6zm-.1-.2v.1m0-.1v.1m-.1.1v.1m.2-.1v.6zm-.1-.2.1.1m-.2 0v.1m.2-.1h.2m.1.1v.6zm.2-.2v.1m0 0h-.1m.1 0h-.1m0 .1v.6-.5m0-.2v.1m0 0v.1m.1 0h-.1m-.2.2h-.2zm.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M26.4 22.4v.5h.1l-.1-.1-.2-.3m-.5-.1h.1v.5h.2v-.6h-.1m-.1-.2q-.3.2-.1.3Zm.7-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 22.4v.5h.1l-.1-.1-.2-.3m-.5-.1h.1v.5h.2v-.6h-.1m-.1-.2q-.3.2-.1.3m.8-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M26.6 21.9v-.1h-.1v-.1h-.2v.3h-.4l-.2.1v.2c0 .3.1 0 .1 0l.3.2q.4 0 .4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 21.9v-.1h-.1v-.1h-.2v.3h-.4l-.2.1v.2c0 .3.1 0 .1 0l.3.2q.4 0 .4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M26.4 21.8v-.1m-.7.7v.5-.2h.2v-.3m.5 0-.2.2v.3H26v-.6m.4-.4h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 21.8v-.1m-.7.7v.5-.2h.2v-.3m.5 0-.2.2v.3H26v-.6m.4-.4h.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    d: "M27.4 22.7v.2q0 .1.1 0v-1.3 1.1m-.1.1h.1Zm0 0h.1Zm0-.1h.1Zm0 0h.1Zm0-.1h.1Zm0-.1h.1Zm0 0h.1Zm0-.1h.1Zm0-.1h.1Zm0 0h.1Zm0-.1h.1Zm0-.1h.1Zm0 0h.1Zm0-.1h.1Zm0-.1h.1Zm0 0h.1Zm0-.1h.1Zm0-.1h.1Zm0 0h.1Zm0-.1h.1Zm0 1.3h.1Zm0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 22.8h.1m0 .1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    d: "M27.6 21.4h.5v-.1h.1zv-.1l.1-.1h.1q0-.2 0 0V21q-.3 0-.4.4L27 21h.2v.2h.1l.1.1-.6.3h.3l.2-.1h.1l-.2.5.1-.1.1-.1h.1v-.1h.1v.1l.1.2v-.1l.1.2V22v.2-.6.1h.1l.1.1.1.1h.1q0-.4-.5-.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.4q.5 0 .6.5v-.2.1l-.2-.1-.2-.1m-.2-.2-.8.2h.3l.2-.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.4q0-.4-.6-.4h.2v.2h.1l.1.1m.2.2q-.4 0-.4.5l.1-.1.1-.1m0 0h.1v-.1m-.1 0v.2m-.1-.1v.2m.3-.4v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 21.6v.2m0 0v.2zv.2q.1-.5-.2-.7m.1.4v-.2m0 0v.1l-.1-.1m.5 0v.1m-.2-.2.1.2m-.2-.2.1.1m-.9 0 .2-.2m0 .1h.2m0 0h.1m-.3-.4h.2m-.1 0 .1.1m0 0h.1m.1.1h.7-.2m0 0h-.2zh-.2l.1.1h-.2m.4-.1h-.2m.1 0h-.2m.1 0h-.2m-.2 0q0-.4.5-.4l-.2.1h.1l-.1.1-.1.1m0 0v.1m.2-.2v.1m-.2.3v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M24.4 19.5h.1v-.1m.2 0 .1.1q.2 0 0-.1zm-.2 0v-.1l.1-.1h.2l.1.1v.3h-.2zm.7-1v.3h.3v-.2H25m.3 0v.3H25l-.1-.2v-.2zm.7-.3v.1h.2-.2v.1l-.1-.1V18l-.1-.1h.1zm.9-.2v.1zv.3zm.8.4.2-.2h.1l-.4.3m.8.3h.1zl-.2.1v.1h-.1v.1zm.4.8h-.2m-.1-.1h-.2.5l-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 19.5.1.1q.2 0 0-.1zm.5-1v.3h.3v-.2H25m1-.3v.1h.2-.2v.1l-.1-.1v-.2l-.1-.1h.1zm1.7.2.2-.2h.1l-.4.3m.8.3h.1zl-.2.1v.1h-.1V19zm.3.7h-.2.5l-.3.3zm-4.3-.1h.1v-.1m0 0v-.1l.1-.1h.2l.1.1v.3h-.2zm1-1v.4H25l-.1-.2v-.2h.4m1.5-.4v.3zm1.9 1.6.1-.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M27 23.4v.2h-.2.2v.3-.1h.2v-.1l.1-.1h-.2zm.8-.3h-.2l.1.2v.2l.1-.2.2.2v-.2l.1-.1h-.2zM29 21v.2h-.2.1v.3l.1-.1h.2v-.2h-.1zm-.5 1.5v.1h.2l-.1.2v.2l-.2-.2-.1.2v-.2l-.1-.2h.2zm.4-.7v.2h.2-.2l.1.3-.1-.1h-.2v-.1l-.1-.1h.2zm-2.6 1.6v.2h.2-.1v.3l-.1-.1H26v-.1l-.1-.1h.2zm-.8-.3v.1h.3l-.2.2v.2l-.1-.2-.2.2v-.3h.1zM24.3 21v.2h.3-.2v.3-.1h-.2v-.1l-.1-.1h.2zm.6 1.5v.1h-.3l.2.2v.2-.2l.2.2v-.2l.1-.2H25zm-.4-.7v.2h-.3.2v.3-.1h.3l-.1-.1.1-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M26.7 20.7v-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m26.8 20.7-.1-.1h-.1zm0 0h-.2zm0 0h-.2zm-.2 0h.2m-.2 0h.2m-.1-.1h-.1m.1 0h-.1zm0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.4 17.5-.1.5.3-.5q0-.1 0 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.5-.1.5.3-.5q0-.1 0 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.5 17.3-.2.5.2-.4.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.3-.2.5.2-.4.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.7 17.2-.2.5.3-.4q0-.1 0 0V17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.7 17.2-.2.5.3-.4q0-.1 0 0V17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m29.7 16.3.3.2q-.7-.2-1.1-.6l-.4-.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.7 16.3.3.2q-.7-.2-1.1-.6l-.4-.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m29.8 16.2.3.2q-.7-.2-1.1-.5c-.3-.2 0 .1 0 .1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.8 16.2.3.2q-.7-.2-1.1-.5c-.3-.2 0 .1 0 .1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m30.3 16.4-.5-.2h-.1l-.4-.2c-.5-.3-.3-.1-.3-.1h.1l.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 16.4-.5-.2h-.1l-.4-.2c-.5-.3-.3-.1-.3-.1h.1l.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28.5 16.5.2.2-.5-.2-.3-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 16.5.2.2-.5-.2-.3-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28 16.6.2.3-.4-.3q-.2-.1 0 0v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 16.6.2.3-.4-.3q-.2-.1 0 0v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28.2 16.5.2.2-.5-.2q-.2-.3 0-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.2 16.5.2.2-.5-.2q-.2-.3 0-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M29.2 16.4s.5.2.1.2c0 0-.7-.2-1-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 16.4s.5.2.1.2c0 0-.7-.2-1-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m29.5 16.3.3.2s-.9-.1-1.3-.5l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5 16.3.3.2s-.9-.1-1.3-.5l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28.7 16.4.2.2-.7-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.7 16.4.2.2-.7-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m29 16.4.2.2q.1.2-1-.3l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 16.4.2.2q.1.2-1-.3l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28.3 16 .2.3-.4-.2-.2-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3 16 .2.3-.4-.2-.2-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28 15.7.4.2.4.3-.5-.2q-.4-.1-.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 15.7.4.2.4.3-.5-.2q-.4-.1-.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.8 16.9v.2l-.3-.2q0-.2.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8 16.9v.2l-.3-.2q0-.2.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M28 16.7v.3l-.4-.2q0-.3.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 16.7v.3l-.4-.2q0-.3.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.6 15.9s.4.7.3.8l-.3-.2-.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 15.9s.4.7.3.8l-.3-.2-.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M28 16s.4.3.3.4l-.4-.2q-.1-.2.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 16 .3.4-.4-.2q-.1-.2.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m27.9 16 .2.6-.3-.3-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.9 16 .2.6-.3-.3-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26 17v.2l.2-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 17v.2l.2-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.2 16.7v.3l.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 16.7v.3l.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.2 17v.3l.2-.1v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 17v.3l.2-.1v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.2 16.7v.4l.2-.4zm0-.5-.1.3.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 16.2-.1.3.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.1 16.2v.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1 16.2v.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m27.6 15.9.1.3-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 15.9.1.3-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.6 16.6v.3l-.1-.3zm-.2.4v.2l-.2-.1v-.2h.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 17v.2l-.2-.1v-.2h.2m.2-.3v.3l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.6 17v.1l-.2-.1q.1-.2.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m27.4 16.3.2.5c0 .2-.3-.3-.3-.4q0-.2.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m27.3 16.4.2.5-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.3 16.5s.1.5 0 .4l-.2-.5zm.5-.8.2.4-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.7 15.8q.2.1.2.4h-.1l-.3-.3zm.2 0 .2.3-.4-.3zm-.5.3.2.7-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 15.8q.2.1.2.4h-.1l-.3-.3zm.2 0 .2.3-.4-.3zm-.5.3.2.7-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m27.3 16.1.1.3-.2-.2zm.2-.1.1.3zm-.5.2q.2 0 .2.3zm1.1-.5.2.3-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m27.9 15.7.2.1.1.2zm.6 0 .7.4-.9-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 15.7.7.4-.9-.3zm-.6-.1.2.1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m28.5 15.8.5.3-.6-.2-.3-.2h.2zm-1.3.4.1.2h-.2zm0 .4v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26.9 16.2.3-.2h.2s0-.4.3-.4h1l.5.3.8.3.3.2-1.2-.6v.1h-.3l-.2-.1H28v-.1h-.4v.3l-.2.1h-.1l-.2.1zm.3.8v.3l-.1-.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 17v.3l-.1-.2v-.2zm-.3-.7.3-.2h.2s0-.4.3-.4h1l.5.3.8.3.3.2-1.2-.6v.1h-.3l-.2-.1H28v-.1h-.4v.3l-.2.1h-.1l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M27.3 16.8v-.2l-.1-.1-.1-.1-.1-.2-.2-.1h-.3l-.3.1v.9h.1v.1h.1v.2h.1v.1h.2v-.2l.2.1v.1h.2v-.1l.1-.2v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27 16.4v.2zm.1.3v.1m0 .2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M25.9 16.2v.3l.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 16.2v.3l.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26 16.2v.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.2v.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m23.7 16.2-.3.2s.9 0 1.4-.4l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7 16.2-.3.2s.9 0 1.4-.4l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M24 16.3s-.4.1 0 .2c0 0 .7-.2 1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.3s-.4.1 0 .2c0 0 .7-.2 1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m24.8 15.8-.5.3.7-.2.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 15.8-.5.3.7-.2.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m24.6 16.4-.1.1.7-.2V16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 16.4-.1.1.7-.2V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m24.3 16.3-.2.2q-.1.2 1-.3l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 16.3-.2.2q-.1.2 1-.3l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m24.1 15.8-1.1.6 1.5-.6m1 .9-.2.2.4-.1q0-.3-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 16.7v.2l.3-.1q0-.3-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M25.5 16.8v.3l.3-.2v-.1zm-.2-.3-.2.3.4-.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 16.5-.2.3.4-.2v-.2zm.2.3v.3l.3-.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.1 16.4-.2.3.5-.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.1 16.4-.2.3.5-.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m24.8 16.4-.1.2.4-.1.4-.3h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 16.4-.1.2.4-.1.4-.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m23.5 16.2-.2.1 1-.3.4-.2-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 16.2-.2.1 1-.3.4-.2-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m23 16.4.6-.2h.1s0 .2.5-.2l.6-.3-1.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.2 16 .6-.3-1.3.4-.4.3.5-.2h.1s0 .2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M25.7 16.8v.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 16.8v.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M25.9 17v.2l.2-.2-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 17v.2l.2-.2-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m26 16.6-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 16.6-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26 16.6v.3zh-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.6v.3zh-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26 16.6v.4l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.6v.4l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M25.7 16.5v.3l.2-.3zM25 16l-.2.2.5-.1.1-.1-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2 15.8.3-.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.4 15.8-.2.2.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.4 15.8-.2.2.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.3 15.7-.4.2-.3.2.5-.1.4-.3m0 .2-.5.4.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 15.7-.4.2-.3.2.5-.1.4-.3m0 .2-.5.4.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M25.5 16q-.2.2-.2.5l.3-.2.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16q-.2.2-.2.5l.3-.2.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.6 16-.2.6.3-.2v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.8 16-.3.8.5-.6zm-.7-.4-.2.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 16-.3.8.5-.6zm-.7-.4-.2.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.2 15.7-.1.2.3-.2zm.3 0-.1.4.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.6 15.8-.1.3.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 15.8-.1.3.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.7 15.9-.1.3.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m25.8 16-.1.3.2-.1zm0 .6v.3l.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M26.3 16.2h-.1l-.3-.2v-.2l-.1-.2h-1.1l-1 .3 1-.2h.3s-.3 0 0 0h.6l.1.3.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 16.2h-.1l-.3-.2v-.2l-.1-.2h-1.1l-1 .3 1-.2h.3s-.3 0 0 0h.6l.1.3.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M24.9 15.7s-.8.2-.7.3l.8-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.3 16.2h.1m-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8759",
    d: "m26.4 17.8-.1.1v.1h.1zh.1v-.4h-.1zl-.3.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8-.1.1v.1h.1zh.1v-.4h-.1zl-.3.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8759",
    d: "M27 17.4v.3h-.2v.1h.1v.2h.1v-.2h.1v.1h.1v-.1H27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 17.4v.3h-.2v.1h.1v.2h.1v-.2h.1v.1h.1v-.1H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcddde",
    d: "m26.2 16.4.2-.2h.4v.3h.1v.2l-.1.1h-.4v-.1h-.2v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27 16.7v.1m.1.4v.1m-.8-.2v.1zm.1.2v.1m.1.1v.2zm0-.2h.1m.4-.1v.1m.1 0v.2-.1m0 .1v.1m.1.1v.1m-.9-.5v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.6 16.4.2-.1zm.3 0h-.3zm-.4.2v.2zm.2 0h.2l-.2-.1m-.1 0v.2zm.1 0 .1.2zm-.5.1h.1m.4-.2h.2zm-.2.1v.2zm.2.1v.2zm.1 0h.1m0 0v.2zm0-.2h.2zm-.1 0v-.2zm0 0-.2-.1.1.2m0 .3v.2zm.1-.2v.1zm0-.1h.2zm-.2-.1v-.1m0 .2v.2zm.2-.3.2-.1zm-.2.3v.2zm0 0v.2zm.2 0 .1.1zm0 0 .2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.7 16.5h.1l.1.1zm0-.2h.1zm-.2 0v-.1zm-.1.4v.1m.1-.2h-.1m-.1 0h-.1m.2-.2h-.1m.2.1.1.1m-.5-.1.1.1zm0 0v.1m0 .5v-.2zm0-.2v.1zm.2-.1v.1zm-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dba05f",
    d: "M26.5 16.4H26l-.1.1.1.1h.7v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16.4H26l-.1.1.1.1h.7v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6262c",
    d: "M26 16.4v-.1h-.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.4v-.1h-.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "m25.7 16.7.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.7 16.7.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "M25.7 16.7h.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 16.7h.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a2e26",
    d: "M26.1 16.7v-.1m.5-.1v-.1zm-.4 0h.1m.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842116",
    d: "M25.9 16.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a2e26",
    d: "M26.6 16.4v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcddde",
    d: "m26.2 16.3-.3-.1-.2-.2-.1-.2H25c-.3 0 0-.1 0-.1h-.5l-.2.1-.6.3-.5.1.7-.3.8-.3h1q.3.1.2.2v.2l.3.2h.1l.1-.1h.8l.2-.2.3-.3h1l.5.2.5.2.3.2.3.2-.3-.2h-.2l-.3-.2-.4-.1h-.3l-.2-.1h-1v.2h-.3l-.1.2h-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "m26.2 16.3-.3-.1-.2-.2-.1-.2H25c-.3 0 0-.1 0-.1h-.5l-.2.1-.6.3-.5.1.7-.3.8-.3h1q.3.1.2.2v.2l.3.2h.1l.1-.1h.8l.2-.2.3-.3h1l.5.2.5.2.3.2.3.2-.3-.2h-.2l-.3-.2-.4-.1h-.3l-.2-.1h-1v.2h-.3l-.1.2h-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 16.3-.3-.1-.2-.2-.1-.2H25c-.3 0 0-.1 0-.1h-.5l-.2.1-.6.3-.5.1.7-.3.8-.3h1q.3.1.2.2v.2l.3.2h.1l.1-.1h.8l.2-.2.3-.3h1l.5.2.5.2.3.2.3.2-.3-.2h-.2l-.3-.2-.4-.1h-.3l-.2-.1h-1v.2h-.3l-.1.2h-.9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBo);
export default __webpack_public_path__ + "static/media/bo.0ff5167592ffccf7bceb3e7144c8879d.svg";
export { ForwardRef as ReactComponent };